<script lang="ts">
	// @ts-nocheck
	import Button from '$lib/components/ui/button/button.svelte';
	import { tourContent } from '$lib/utils/tourContent';
	import * as Accordion from '$lib/components/ui/accordion';
	import { Check } from 'lucide-svelte';
	import { cubicInOut } from 'svelte/easing';
	import { crossfade, fade, fly } from 'svelte/transition';
	import { highlightImages } from '$lib/utils/images';

	let { tour } = $props();

	let highlights = tourContent.find((t) => t.productCode === tour.productCode)?.accordionContent;
	let current = $state(0);

	function incrementCurrent() {
		if (highlights && current >= highlights.length - 1) {
			current = 0;
		} else {
			current += 1;
		}
	}

	setInterval(incrementCurrent, 7000);

	const [send, receive] = crossfade({
		duration: 500,
		easing: cubicInOut
	});

	function handleAnchorClick(event) {
		event.preventDefault();
		const link = event.currentTarget;
		const anchorId = new URL(link.href).hash.replace('#', '');
		const anchor = document.getElementById(anchorId);
		window.scrollTo({
			top: anchor.offsetTop,
			behavior: 'smooth'
		});
	}
</script>

<!-- HIGHLIGHTS -->
{#if tourContent.some((t) => t.productCode === tour.productCode && t.accordionContent)}
	<section class="relative hidden overflow-hidden lg:block">
		<div class="mx-auto max-w-7xl px-4 py-24">
			<h2
				class=" mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
			>
				Some of the things you can expect to see and do
			</h2>
			<div class="flex w-full flex-col py-12">
				<nav aria-label="Progress" class="mx-auto pb-28 pt-6">
					<ol role="list" class="flex items-center">
						{#each highlights as item, index}
							<li
								key={item}
								class={index !== highlights.length - 1
									? 'relative h-8  pr-8 sm:pr-20'
									: 'relative h-8 '}
							>
								{#if index === current}
									<div
										id="bus"
										in:send={{ key: 'item' }}
										out:receive={{ key: 'item' }}
										class="absolute -left-2 -top-1 h-12 w-12 bg-background"
										style:z-index={20}
									>
										<svg
											width="60"
											height="36"
											viewBox="0 0 60 36"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g clip-path="url(#clip0_10_399)">
												<path
													d="M8.55469 0H53.0203C54.4688 0 55.7719 0.946875 56.2125 2.32031L59.5266 12.4922C59.85 13.4672 60 14.4938 60 15.5297V30.0047H49.875C49.6781 33.1688 47.0625 35.6719 43.8422 35.6719C40.6219 35.6719 38.0063 33.1688 37.8094 30.0047H21.5016C21.3047 33.1688 18.675 35.6719 15.4688 35.6719C12.2625 35.6719 9.63281 33.1688 9.44062 30.0047H0V8.55469C0 3.83438 3.83437 0 8.55469 0ZM41.2781 30.0094C41.4609 31.2609 42.5437 32.2266 43.8422 32.2266C45.1406 32.2266 46.2375 31.2656 46.4203 30.0094C46.4344 29.8875 46.4531 29.7656 46.4531 29.6297C46.4531 29.2172 46.3641 28.8375 46.1625 28.4859C45.7641 27.6141 44.8641 27.0187 43.8422 27.0187C42.8203 27.0187 41.9344 27.6141 41.5219 28.4859C41.3391 28.8375 41.2453 29.2172 41.2453 29.6297C41.2453 29.7656 41.2641 29.8875 41.2781 30.0094ZM12.8906 30.0094C13.0734 31.2609 14.175 32.2266 15.4688 32.2266C16.7625 32.2266 17.8547 31.2656 18.0328 30.0094C18.0469 29.8875 18.0656 29.7656 18.0656 29.6297C18.0656 29.2172 17.9766 28.8375 17.7891 28.4859C17.3766 27.6141 16.4906 27.0187 15.4688 27.0187C14.4469 27.0187 13.5469 27.6141 13.1484 28.4859C12.9469 28.8375 12.8578 29.2172 12.8578 29.6297C12.8578 29.7656 12.8766 29.8875 12.8906 30.0094ZM1.52813 28.4812H9.52969C10.0641 25.6875 12.525 23.5828 15.4734 23.5828C18.4219 23.5828 20.8781 25.6875 21.4125 28.4812H37.9031C38.4375 25.6875 40.8984 23.5828 43.8469 23.5828C46.7953 23.5828 49.2516 25.6875 49.7859 28.4812H58.4719V15.5297C58.4719 14.6578 58.3359 13.7906 58.0734 12.9469L54.7641 2.79375C54.5203 2.04844 53.8172 1.52813 53.0203 1.52813H8.55469C6.61406 1.52813 4.86094 2.32031 3.59063 3.59062C2.30625 4.85625 1.52813 6.61406 1.52813 8.55469V28.4812Z"
													fill="#38491D"
												/>
												<path
													d="M9.35625 4.53284H14.0391C14.5172 4.53284 14.9062 4.9219 14.9062 5.40002V12.7875C14.9062 13.261 14.5172 13.6547 14.0391 13.6547H6.05625C5.57812 13.6547 5.18906 13.2656 5.18906 12.7875V8.70002C5.18906 6.40784 7.05468 4.53752 9.35156 4.53752L9.35625 4.53284Z"
													fill="#38491D"
												/>
												<path
													d="M49.1297 4.53284H50.9016C51.2766 4.53284 51.6094 4.77659 51.7266 5.13284L54.5438 13.8047C54.7219 14.3485 54.8109 14.911 54.8109 15.4782V19.9172C54.8109 20.3953 54.4219 20.7797 53.9438 20.7797H49.1297C48.6516 20.7797 48.2625 20.3907 48.2625 19.9172V5.40002C48.2625 4.9219 48.6516 4.53284 49.1297 4.53284Z"
													fill="#38491D"
												/>
												<path
													d="M44.3625 4.53284H34.4016C34.1625 4.53284 33.9656 4.72971 33.9656 4.96877V13.2188C33.9656 13.4578 34.1578 13.6547 34.4016 13.6547H44.3672C44.6063 13.6547 44.8031 13.4578 44.8031 13.2188V4.96877C44.8031 4.72971 44.6063 4.53284 44.3672 4.53284H44.3625Z"
													fill="#38491D"
												/>
												<path
													d="M19.5469 4.53284H29.8828C30.1219 4.53284 30.3141 4.72971 30.3141 4.96877V13.2188C30.3141 13.4578 30.1219 13.6547 29.8828 13.6547H19.5469C19.3078 13.6547 19.1156 13.4625 19.1156 13.2188V4.96877C19.1156 4.72971 19.3078 4.53284 19.5469 4.53284Z"
													fill="#38491D"
												/>
											</g>
											<defs>
												<clipPath id="clip0_10_399">
													<rect
														width="60"
														height="35.6719"
														fill="white"
														transform="matrix(-1 0 0 1 60 0)"
													/>
												</clipPath>
											</defs>
										</svg>
									</div>
								{/if}
								{#if index < current}
									<div aria-hidden="true" class="absolute inset-0 flex items-center">
										<div class="h-0.5 w-full bg-[#194139]"></div>
									</div>
									<button
										aria-label="highlight-select"
										onclick={() => (current = index)}
										class="relative flex h-8 w-8 items-center justify-center rounded-full bg-[#194139] transition hover:bg-[#2f574e]"
									>
										<Check aria-hidden="true" class="h-5 w-5 text-white" />
										<span class="sr-only">{item.title}</span>
									</button>
									<span
										class="absolute -ml-8 flex w-24 min-w-0 items-center justify-center pt-6 text-center text-xs"
									>
										{item.title}
									</span>
								{:else if index === current}
									<div aria-hidden="true" class="absolute inset-0 flex items-center">
										<div class="h-0.5 w-full bg-gray-200"></div>
									</div>
									<button
										aria-label="highlight-select"
										onclick={() => (current = index)}
										class="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-[#194139] bg-white"
									>
										<span aria-hidden="true" class="h-2.5 w-2.5 rounded-full bg-[#194139]"></span>
										<span class="sr-only">{item.title}</span>
									</button>
									<span
										class="absolute -ml-8 flex w-24 min-w-0 flex-col items-center justify-center pt-6 text-center text-xs font-semibold text-[#194139]"
									>
										{item.title}
									</span>
								{:else}
									<div aria-hidden="true" class="absolute inset-0 flex items-center">
										<div class="h-0.5 w-full bg-gray-200"></div>
									</div>
									<button
										aria-label="highlight-select"
										onclick={() => (current = index)}
										class="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400"
									>
										<span
											aria-hidden="true"
											class="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"
										></span>
										<span class="sr-only">{item.title}</span>
									</button>
									<span
										class="absolute -ml-8 flex w-24 min-w-0 items-center justify-center pt-6 text-center text-xs"
									>
										{item.title}
									</span>
								{/if}
							</li>
						{/each}
					</ol>
				</nav>
				<div class="mx-auto w-full">
					<div class="relative h-[450px]">
						{#key current}
							<div
								in:fly={{ x: 100, duration: 300, delay: 300 }}
								out:fly={{ x: -100, duration: 300 }}
								class="relative flex h-[450px] items-center overflow-hidden bg-gray-900 px-6 py-20 shadow-xl sm:rounded-3xl"
							>
								<enhanced:img
									class="absolute inset-0 h-full w-full object-cover"
									src={Object.entries(highlightImages).find(
										([key, value]) => key === highlights[current].image
									)[1].default}
									alt={highlights[current].title}
									sizes="(min-width: 1280px) 1280px, 100vw"
								/>

								<div class="absolute inset-0 bg-foreground/40 mix-blend-multiply"></div>

								<div class="relative mx-auto max-w-2xl lg:mx-0">
									<h3
										class=" mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight text-background transition-colors first:mt-0 lg:text-3xl"
									>
										{highlights[current].title}
									</h3>
									<figure>
										<blockquote class=" mt-6 text-lg leading-8 text-white">
											{@html highlights[current].content}
										</blockquote>
									</figure>
								</div>
							</div>
						{/key}
					</div>
				</div>
			</div>
		</div>
	</section>

	<!-- ACCORDION -->

	<section class="relative overflow-hidden bg-[#194139] lg:hidden">
		<div class="mx-auto max-w-7xl px-4 py-12">
			<h2
				class="mx-auto mt-10 scroll-m-20 pb-2 text-center font-heading text-2xl font-semibold tracking-tight text-background transition-colors first:mt-0 lg:text-3xl"
			>
				{tourContent.find((t) => t.productCode === tour.productCode)?.accordionHeadline}
			</h2>

			<div class="mx-auto max-w-3xl">
				<Accordion.Root type="single" class="w-full  py-12 text-background">
					{#each tourContent.find((t) => t.productCode === tour.productCode)?.accordionContent as item, index}
						<Accordion.Item value="item-{index}" class="border-background/40">
							<Accordion.Trigger class="text-lg font-semibold">{item.title}</Accordion.Trigger>
							<Accordion.Content>
								{@html item.content}

								<enhanced:img
									class="mb-4 mt-6 aspect-video w-full rounded-lg object-cover"
									src={Object.entries(highlightImages).find(([key]) => key === item.image)[1]
										.default}
									alt={item.title}
									sizes="(min-width: 768px) 768px, 100vw"
									loading="lazy"
								/>
							</Accordion.Content>
						</Accordion.Item>
					{/each}
				</Accordion.Root>
			</div>
			<div class="mx-auto w-full text-center">
				<Button
					data-sveltekit-noscroll
					href="#book"
					on:click={handleAnchorClick}
					class="pointer-events-auto mx-auto mt-8 w-44 rounded-full bg-tt-red px-6 text-lg font-semibold hover:bg-tt-red/90 "
					>Book now</Button
				>
			</div>
		</div>
	</section>
{/if}
